export default "__VITE_ASSET__CVAGAE00__"